/**
 * A dictation turned into text (R57 to R62): the recording goes as the raw request body, with the
 * interface's language as a hint. Nothing is kept on either side; the text comes back for the
 * trainer to correct and send.
 */

import { postAiTranscriptions } from '~/shared/api/generated/endpoints/ai/ai';
import { ApiError } from '~/shared/api/mutator';

import { aiRefusal, type AiRefusal } from '../model/refusals';

/** What was heard (`''` when nothing was), or why the recording was not transcribed. */
export type AiTranscription =
  | { readonly outcome: 'heard'; readonly text: string }
  | { readonly outcome: 'refused'; readonly refusal: AiRefusal };

export async function transcribe(audio: Blob, language: 'pl' | 'en'): Promise<AiTranscription> {
  try {
    const answer = await postAiTranscriptions(audio, { language });
    return { outcome: 'heard', text: (answer.text ?? '').trim() };
  } catch (error) {
    if (!(error instanceof ApiError)) return { outcome: 'refused', refusal: { kind: 'failed' } };
    return { outcome: 'refused', refusal: aiRefusal({ status: error.status, code: error.code, problem: error.problem }) };
  }
}
